import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useLoaderData, useParams} from "react-router-dom";
import {UserContext} from "../../../../Contexts/UserContext";
import {GET, POST} from "../../../../Hooks/RequestV2";
import {useForm, UseFormReturn} from "react-hook-form";
import {MerchantLimitListLoader, ProductLimit, Notification, TYPE, TERMS} from "./MerchantLimitListInterfaces";

export default function MerchantLimitList(): React.ReactElement {
    const loader: MerchantLimitListLoader = useLoaderData() as MerchantLimitListLoader;
    const {t} = useTranslation();
    const userContext = useContext(UserContext);
    const {receiver_id} = useParams();
    const [productsLimitsOptions, setProductsLimitsOptions] = useState<any[]>([]);
    const [notification, setNotification] = useState<Notification | null>(null);

    const formProductsList = useForm();
    const form = useForm({defaultValues: loader as any});

    const receiverName = userContext && userContext.user ? userContext?.user.receiver.contractor.receivers.find((receiver: any) => parseInt(receiver.id) === parseInt(receiver_id as string))?.name : '';

    useEffect(() => {
        GET('/user/product-limit/show')
            .then((response) => {
                if (response.status === 200){
                    return response.json();
                }
            })
            .then((json) => {
                setProductsLimitsOptions(json);
            });
    }, []);

    function addProductLimit(formData: any): void {
        const data = JSON.parse(formData.productLimitId as string);
        const current = form.getValues('product_limit' as any) || [];

        const exists = current.some(
            (item: any) => item.product_limit_id === data.id
        );

        if (exists) return;

        const productLimit: ProductLimit = {
            name: data.name,
            amount: 0,
            id: parseInt(data.id),
            term: 0,
            type: 0
        };

        const limits = [...form.getValues('product_limit' as any), productLimit];

        form.setValue('product_limit', limits);
    }

    function send(data: MerchantLimitListLoader): void {
        data.receiver_active_merchant_limit = true;

        POST('/user/merchant-limit/edit/'+receiver_id, data)
            .then((response) => {
                if (response.ok){
                    setNotification({class: 'success', message: t('user-page.merchant-limit.success')});
                } else {
                    setNotification({class: 'error', message: t('user-page.merchant-limit.error')});
                }
            });
    }


    if (userContext?.user && !userContext.user.merchantLimit){
        return <></>;
    }

    return (
        <>
            <h1>
                <button className={'btn teal'} onClick={() => window.history.back()} type={'button'} >
                    <i className="fas fa-chevron-left" />
                    Wstecz
                </button>
                {receiverName}
            </h1>

            {notification ?

                <div className={'notification'+(notification?.class ? ' '+notification.class : '')} >
                    {notification?.message}
                </div>

            : null}


            {productsLimitsOptions.length > 0 ?

                <div className={'add-group'} >
                    <form onSubmit={formProductsList.handleSubmit(addProductLimit)} className={'add-form'} >
                        <select defaultValue={productsLimitsOptions.length > 0 ? JSON.stringify({id: productsLimitsOptions[0].id, name: productsLimitsOptions[0].name}) : JSON.stringify({id: 0, name: ''})} {...formProductsList.register('productLimitId')} >
                            {productsLimitsOptions.map((item: any, index: number) => {
                                return <option key={index} value={JSON.stringify({id: item.id, name: item.name})} >{item.name}</option>;
                            })}
                        </select>

                        <button className={'btn'} >{t('user-page.merchant-limit.add')}</button>
                    </form>
                </div>

                : null}


            <form onSubmit={form.handleSubmit(send)} className={'form'} >
                <table className={'table-data'}>
                    <thead>
                        <tr>
                            <th className={'name'} >{t('user-page.merchant-limit.name')}</th>
                            <th>{t('user-page.merchant-limit.limit')}</th>
                            <th>{t('user-page.merchant-limit.term')}</th>
                            <th>{t('user-page.merchant-limit.type')}</th>
                            <th>{t('user-page.merchant-limit.options')}</th>
                        </tr>
                    </thead>
                    <tr>
                        <td>{t('user-page.merchant-limit.general')}</td>
                        <td><input type={'number'} min={0.01} step={0.01} {...form.register('receiver_merchant_limit_new')} /></td>
                        <td>
                            <select defaultValue={form.watch('receiver_term' as any)} {...form.register('receiver_term')} >
                                <option value="" disabled hidden >-- {t('user-page.merchant-limit.select')}</option>
                                {Object.entries(TERMS).map(([key, label]: any) => <option value={key} >{t('user-page.merchant-limit.types.'+label)}</option>)}
                            </select>
                        </td>
                        <td></td>
                        <td></td>
                    </tr>
                    {(form.watch('product_limit' as any) as any[]).map((item: any, index: number) => {
                        return <Field merchantLimit={item} form={form} index={index} />;
                    })}
                </table>

                <div className={'buttons'} >
                    <button className={'btn'} >{t('user-page.merchant-limit.save')}</button>
                </div>
            </form>
        </>
    );
}

function Field({merchantLimit, form, index}: {merchantLimit: any, form: UseFormReturn, index: number}): React.ReactElement {
    const {t} = useTranslation();
    function removeProductLimit(id: number): void {
        const filtered = (form.getValues('product_limit' as any) as object[]).filter((item: any) => item.id !== id);
        form.setValue('product_limit', filtered);
    }

    return (
        <tr key={index} >
            <td>{merchantLimit.name}</td>
            <td><input type={'number'} min={0.01} step={0.01} {...form.register('product_limit.'+index+'.amount_new')} /></td>
            <td>
                <select defaultValue={merchantLimit.term} {...form.register('product_limit.'+index+'.term')} >
                    {Object.entries(TERMS).map(([key, label]: any) => <option value={key} >{t('user-page.merchant-limit.types.'+label)}</option>)}
                </select>
            </td>
            <td>
                <select defaultValue={merchantLimit.term} {...form.register('product_limit.'+index+'.type')} >
                    {Object.entries(TYPE).map(([key, label]: any) => <option value={key} >{t('user-page.merchant-limit.t.'+label)}</option>)}
                </select>
            </td>
            <td>
                <button className={'btn red'} onClick={() => removeProductLimit(merchantLimit.id)} >{t('user-page.merchant-limit.remove')}</button>
            </td>
        </tr>
    );
}